import {
  GET_ORDER_SETTINGS,
  CREATE_ORDER_SETTINGS,
  UPDATE_ORDER_SETTINGS,
} from 'actions/types';
import { transformActions } from 'utils/';

let cacheList = [];
const initialState = [];

/**
  @description Stores company's order setting array details in redux state.
  @param {[]} state
  @param {{ payload : [] type : string  }} action
  @returns {[]}
 */
export function orderSetting(state = initialState, action) {
  const { type, payload } = action;
  const actions = [GET_ORDER_SETTINGS, CREATE_ORDER_SETTINGS];
  const success = transformActions(actions, 'SUCCESS');
  const failure = transformActions(actions, 'FAILURE');
  if (success.includes(type)) {
    cacheList = payload;
    return cacheList;
  }
  if (failure.includes(type)) {
    return cacheList;
  }
  if ([`${UPDATE_ORDER_SETTINGS}_SUCCESS`].includes(type)) {
    const { id, updatedValues } = payload;
    const data = cacheList.map(function (order) {
      if (order.id === id) {
        return { ...order, ...updatedValues };
      }
      return order;
    });
    cacheList = data;
    return cacheList;
  }
  return state;
}
